import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Guarda rutas autenticadas (y opcionalmente con rol admin o permiso recurso/accion).
 * Mientras `loading=true` no renderiza para evitar parpadeos.
 *
 * Props:
 *  - superAdminOnly: solo isSuperAdmin (admin/dir_comercial) — config del sistema.
 *  - adminOnly: solo isAdmin (incluye admin_comercial) — gestión comercial avanzada.
 *  - permiso: { recurso, accion='leer' } — si rol no tiene permiso, redirige a `/`.
 */
export const ProtectedRoute = ({ children, adminOnly = false, superAdminOnly = false, permiso = null }) => {
  const { user, loading, isSuperAdmin, isAdmin, hasPermission } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (superAdminOnly && !isSuperAdmin) return <Navigate to="/" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  if (permiso && !hasPermission(permiso.recurso, permiso.accion || 'leer')) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedRoute;
